<!--Profile popup start -->
<div class="modal-header">
  <h4 class="modal-title">Profile</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss('cancel')"></button>
</div>
<div class="modal-body">
  <div class="modal-color">
    <div class="row dsplflx">
      <div class="col-lg-2 col-md-3 col-sm-3">
        <div class="img img-wrapper">
          <div class="field-item user-img">
            <div *ngIf="profileImageSrc" class="user-img">
              <img [src]="profileImageSrc" />
            </div>
            <div *ngIf="!profileImageSrc" class="user-img">
              <img src="assets/images/team/profile.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-10 col-md-9 col-sm-9">
        <div class="field-item user-details pd all-tag-pad">
          <div *ngIf="user.firstName">
            <h4 class="title profile">
              {{user.firstName}} {{user.lastName}}
            </h4>
          </div>
          <div class="col-12">
            <div class="city-name">
              <div class="addrs" *ngIf="user.city">
                <h6 class="hdr">City</h6>
                <p class="ftr">{{user.city}}</p>
              </div>
              <div class="addrs" *ngIf="user.state">
                <h6 class="hdr">State</h6>
                <p class="ftr">{{user.state}}</p>
              </div>
              <div class="addrs" *ngIf="user.country">
                <h6 class="hdr">Country</h6>
                <p class="ftr">{{user.country}}</p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div *ngIf="age !== null">
              <h6 class="hdr">Age</h6>
              <p class="ftr">{{age}} year</p>
            </div>
            <div *ngIf="user.company">
              <h6 class="hdr">Company</h6>
              <p class="ftr">{{user.company}}</p>
            </div>
          </div>
          <div class="col-12">
            <div *ngIf="user.aboutMe">
              <h6 class="hdr">About Me</h6>
              <p class="ftr">{{user.aboutMe}}</p>
            </div>
          </div>
          <div class="col-12" *ngIf="isAddButtonVisible">
            <div>
              <h6 class="hdr">Wants to add some personalize message</h6>
              <p class="ftr"><textarea rows="2" class="form-control" [(ngModel)]="personalizedMsg" [ngModelOptions]="{standalone: true}" placeholder="Enter text"></textarea></p>
            </div>
          </div>
          <div class="col-12 pop-btn-div1">
            <div class="mnag">
              <button (click)="dismiss('ok')"  class="basicbtn declinebtn" type="button">Cancel</button>
              <button *ngIf="isAddButtonVisible" (click)="openSettingModal(user)"  class="basicbtn approvebtn ml-2" type="button">Add Contact</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Profile Popup end -->